import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from "@angular/common/http";
import { Observable, catchError, throwError } from "rxjs";
import { SecurityService } from "./service/security.service";
import { Router } from "@angular/router";

@Injectable()
export class SecurityHeaderInterceptor implements HttpInterceptor {
  constructor(
    private securityService: SecurityService,
    private router: Router
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let setHeaders: any = {
      Accept: "application/json",
      Authorization: "Bearer " + this.securityService.getToken(),
    };

    if (!(request.body instanceof FormData)) {
      setHeaders["Content-Type"] = "application/json";
    }

    const req = request.clone({ setHeaders, withCredentials: false });

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          window.location.reload();
          this.securityService.signOut();
          this.router.navigate(["/", "logout"]);
        }
        return throwError(error);
      })
    );
  }
}
